<template>
  <div>
    <div class="loader centrado" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <template v-if="series.length > 0">
      <apexchart
        type="bar"
        height="500"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </template>
    <template v-else>
      <h4>
        No se encuentra la información para visualizar esta grafica, por favor
        comuniquese con el administrador del sistema.
      </h4>
    </template>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import VueApexCharts from "vue-apexcharts";
import Datepicker from "vuejs-datepicker";
Vue.component("apexchart", VueApexCharts);
export default {
  name: "BarChart",
  data: () => {
    return {
      anio: null,
      mes: null,
      loading: true,
      series: [
        {
          data: [],
        },
        {
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 430,
        },
        legend: {
          position: "top",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: "12px",
            colors: ["#fff"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [],
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 150,
              },
              legend: {
                position: "top",
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  props: {
    grafica: null,
  },
  components: {
    Datepicker,
  },
  methods: {
    datosGrafica() {
      this.$store
        .dispatch("presupuesto/datosGrafica", { nombre: this.grafica })
        .then((data) => {
          if (data.datos) {
            var datos = data.datos[this.user.id];
            this.chartOptions = {
              ...this.chartOptions,
              ...{
                xaxis: {
                  categories: datos.xaxis.categories,
                },
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return "$" + value.toLocaleString("es-CO");
                    },
                  },
                },
              },
            };
            this.series = [
              {
                name: "Presupuesto propuesto",
                data: datos.series.data1,
              },
              {
                name: "Cumplimiento presupuesto",
                data: datos.series.data2,
              },
            ];
          } else {
            this.series = [];
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.series = [];
          console.log(this.series.length);
          this.loading = false;
        });
    },
    fixDate(event) {
      return this.$moment(event).format("YYYY");
    },
  },
  mounted() {
    this.datosGrafica();
  },
};
</script>
<style>
.centrado {
  display: flex;
  justify-content: center; /* center horizontally */
  align-items: center;
}
</style>